const getUniqBy = (a, key) => {
    let seen = {};
    return a.filter((item) => {
        let k = item[key];
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
}

export default getUniqBy;